import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles()((theme: Theme) => ({
  scoreCards: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',

    '& > div': {
      flex: 1,
      minHeight: 0,

      '& > div': {
        height: '100%',
        gap: '0.5rem',
      },
    },
  },

  allGood: {
    '& svg': {
      color: theme.palette.success.main,
      width: '100%',
      height: '6.5rem',
      marginTop: '-1rem',
    },
  },

  text: {
    fontWeight: 'bold',
    fontSize: '1.5rem',
  },
}));
